import React, { useState, useMemo,useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
// @ts-ignore CSS is loaded by the application bundler.
import 'ag-grid-community/styles/ag-grid.css';
// @ts-ignore CSS is loaded by the application bundler.
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FaUser, FaBuilding,FaArrowUp,FaCubes} from 'react-icons/fa';
import SearchBar from '../../SearchBarTable/SearchBarTable';
// @ts-ignore CSS is loaded by the application bundler.
import "../AgGridTheme.css";
import SortHeader from '../SortingHeader';
// import { ColDef } from 'ag-grid-community';
import {
  ClientSideRowModelModule,
  ModuleRegistry,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule
} from "ag-grid-community";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  // ColumnHoverModule,
  PaginationModule,
]);

interface CompanyTableProps {
  companies: any[];
  onSearchChange: (searchQuery: string) => void;
  onClearSelection: () => void;
  selectedCompany: any | null;
  onRowSelect: (asset: any) => void;
  selectedRow: string | null;
}

const CompanyTable: React.FC<CompanyTableProps> = ({
  companies,
  onSearchChange,
  onClearSelection,
  selectedCompany,
  onRowSelect,
  selectedRow,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [gridApi, setGridApi] = useState<any>(null);
  const gridRef = useRef<AgGridReact>(null);

  // const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setSearchQuery(e.target.value);
  //   onSearchChange(e.target.value);
  // };
  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
  };
  const filteredCompanies = useMemo(() => {
    const lowerSearchQuery = searchQuery.toLowerCase();
  
    return companies.filter((company) => {
      const domainMatch = Array.isArray(company.domain_names)
        ? company.domain_names.join(', ').toLowerCase().includes(lowerSearchQuery)
        : false;
  
      const assetMatch = Array.isArray(company.assets)
        ? company.assets.some((asset: any) =>
            asset.asset_name?.toLowerCase().includes(lowerSearchQuery) ||
            asset.percent_ownership?.toString().toLowerCase().includes(lowerSearchQuery)
          )
        : false;
  
      return (
        company.company_name?.toLowerCase().includes(lowerSearchQuery) ||
        company.owner_name?.toLowerCase().includes(lowerSearchQuery) ||
        domainMatch ||
        assetMatch
      );
    });
  }, [companies, searchQuery]);
  
  const columnDefs = useMemo(
    () => [
    {
      headerName: "Company Name",
      field: "company_name",
      sortable: true, 
      flex: 1,
      minWidth: 250,
      // enableRowGroup: true,
      cellRenderer: (params: any) => (
        <div className="flex items-center gap-2">
          {params.value}
        </div>
      ),
      headerComponent: SortHeader, 
      headerComponentParams: {
        displayName: 'Company Name',
        enableSorting: true,
        icon: <FaBuilding className="text-gray-600" />
      },
      headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
    },  
    // {
    //   headerName: 'Owner Name',
    //   field: 'owner_name',
    //   // sortable: true,
    //   // filter: "agTextColumnFilter",
    //   // floatingFilter: true,
    //   // width: 250,
    //   flex: 1,
    //   minWidth: 250,
    //   headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer",
    //   // floatingFilterComponent: CustomFloatingFilter, 
    //   enableRowGroup: true,
    //   cellRenderer: (params: any) => (
    //     <div className="flex items-center gap-2">
    //       {params.value}
    //     </div>
    //   ),
    //   headerComponent: () => (
    //     <div className="flex items-center gap-2">
    //      <FaUser className="text-gray-600" />
    //       <span>Owner Name</span>
    //     </div>
    //   ),
    // },
    {
      headerName: "Owner Name",
      field: "owner_name",
       // filter: "agTextColumnFilter",
      // floatingFilter: true,
      // width: 250,
      sortable: true, 
         // floatingFilterComponent: CustomFloatingFilter, 
      flex: 1,
      minWidth: 250,
      // enableRowGroup: true,
      cellRenderer: (params: any) => (
        <div className="flex items-center gap-2">
          {params.value}
        </div>
      ),
      headerComponent: SortHeader, 
      headerComponentParams: {
        displayName: 'Owner Name',
        enableSorting: true,
        icon: <FaUser className="text-gray-600" />
      },
      headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
    },  
    // {
    //   headerName: 'Domain Names',
    //   field: 'domain_names',
    //   // sortable: false,
    //   // filter: "agTextColumnFilter",
    //   //   floatingFilter: true,
    //     // width: 250,
    //     flex: 1,
    //     minWidth: 250,
    //     headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer",
    //     // floatingFilterComponent: CustomFloatingFilter, 
    //     enableRowGroup: true,
    //     autoHeight: true,
    //     cellRenderer: (params: any) => {
    //       const domains = params.value;
    //       if (!Array.isArray(domains) || domains.length === 0) return 'N/A';
    //       return (
    //         <div style={{ whiteSpace: 'pre-line' }}>
    //           {domains.join('\n')}
    //         </div>
    //       );
    //     },
    //     headerComponent: () => (
    //       <div className="flex items-center gap-2">
    //        <FaGlobe className="text-gray-600" />
    //         <span>Domain Names</span>
    //       </div>
    //     ),
    // },
    {
      headerName: 'Domain Names',
      field: 'domain_names',
      sortable: true,
      cellDataType: false,
      flex: 1,
      minWidth: 250,
      headerComponent: SortHeader,
      cellRenderer: (params: any) => {
        const domains = params.value;
        if (!Array.isArray(domains) || domains.length === 0) return 'N/A';
        return <div style={{ whiteSpace: 'pre-line' }}>{domains.join('\n')}</div>;
      }
    },
    {
      headerName: "Assets",
      field: "assets",
      sortable: true, 
      flex: 1,
      minWidth: 250,
      // enableRowGroup: true,
      cellDataType: false,
      autoHeight: true,
      cellRenderer: (params: any) => {
        const assets = params.value;
        if (!Array.isArray(assets) || assets.length === 0) return 'No Assets';
        return (
          <div style={{ whiteSpace: 'pre-line' }}>
            {assets.map((a: any) => `${a.asset_name} (${a.percent_ownership ?? 0}%)`).join('\n')}
          </div>
        );
      },
      headerComponent: SortHeader, 
      headerComponentParams: {
        displayName: 'Assets',
        enableSorting: true,
        icon: <FaCubes className="text-gray-600" />
      },
      headerClass: "p-4 text-left text-base font-bold text-gray-700 bg-gray-200 cursor-pointer"
    },  
  ],
  []
);

const defaultColDef = useMemo(() => ({
  // sortable: true,
  // filter: true,
  // floatingFilter: true,
  resizable: true,
  cellStyle: {
    padding: "8px 12px",
    fontSize: "16px",
    fontFamily: "'Poppins', sans-serif",
    color: "#374151",
  },
}), []);

  return ( 
    <div className="p-4 bg-white shadow-md rounded-xl font-poppins">
      {/* <div className="flex justify-between mb-4">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search companies..."
          className="border border-gray-300 p-2 rounded w-1/3"
        />
      </div> */}
       {/* <div className="flex justify-between items-center space-x-4 mb-6"> */}
       <div className="flex justify-between items-center mb-4">
           <div className="flex items-center bg-gray-200 px-3 py-2 rounded-full  max-w-md">
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={handleSearchChange}
          placeholder="Search companies..."
        />
      </div>
      </div>
      <div
        // className="ag-theme-alpine font-poppins text-base text-gray-700"
        className="w-full ag-theme-alpine font-poppins text-base text-gray-700"
        style={{ height: "var(--admin-tab-grid-height, max(475px, calc(100dvh - 320px)))", overflow:'auto', border: '1px solid #E7E4FF', borderRadius: '8px'}}
      >
      <AgGridReact
        theme="legacy"
        rowData={filteredCompanies}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        domLayout="normal"
        // rowSelection="single"
        // rowSelection={{ mode: 'singleRow' }}

        // columnDefs={columnDefs}
        // defaultColDef={defaultColDef}
        // rowHeight={40}
        rowHeight={60}
        headerHeight={55}
        // floatingFiltersHeight={40}
        pagination={true}
        paginationPageSize={50}
        // rowGroupPanelShow="always"
        // groupDisplayType="multipleColumns"
        className="ag-theme-alpine"
        suppressRowHoverHighlight={false}
        // columnHoverHighlight={true}
        onGridReady={(params) => setGridApi(params.api)}
        onRowClicked={(event) => onRowSelect(event.data)}
        getRowClass={(params) =>
          params.data.company_name === selectedRow ? 'bg-gray-200' : ''
        }
        getRowHeight={(params) => {
          const lines = Math.max(
            params.data?.domain_names?.length || 1,
            params.data?.assets?.length || 1
          );
          return 60 + (lines - 1) * 25; // base height + 20px per extra line
        }}
      />
    </div>
       </div>
  );
};
export default CompanyTable;
